<!-- [class.ring-4]="estado() === 'terminado'"
  [class.ring-red-300]="estado() === 'terminado'" -->
<div
  class="bg-white rounded-lg shadow-md border-t-4 flex flex-col h-full relative transition-all hover:shadow-lg"
  [class.buzz-attention]="estado() === 'terminado'"
  [style.animation-delay]="estado() === 'terminado' ? animationDelay() : null"
  [class.opacity-80]="estado() === 'terminado'"
  [class.border-green-500]="estado() === 'activo'"
  [class.border-orange-500]="estado() === 'proximo-terminar'"
  [class.border-red-500]="estado() === 'terminado'"
  [class.border-gray-500]="estado() === 'sin-tiempo'"
>
  <div
    class="flex justify-between items-start gap-2 p-2"
    [class.bg-green-300]="estado() === 'activo'"
    [class.bg-orange-300]="estado() === 'proximo-terminar'"
    [class.bg-red-300]="estado() === 'terminado'"
    [class.bg-gray-300]="estado() === 'sin-tiempo'"
  >
    <div class="min-w-0 flex-1">
      <h3 class="text-base font-bold text-slate-900 min-w-0 leading-tight">
        <span class="flex items-start gap-1 min-w-0">
          <i class="bi bi-person-fill text-xs mt-0.5 shrink-0"></i>
          <span
            class="min-w-0 overflow-hidden [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical] wrap-break-words"
          >
            {{ gestion_tiempo().titulo }}
          </span>
        </span>
      </h3>
      <p class="text-xs text-slate-600">Gestión de tiempo</p>
    </div>
    <div class="flex items-center gap-1.5 shrink-0">
      <span
        class="text-xs font-semibold px-2.5 py-0.5 rounded whitespace-nowrap"
        [class.bg-green-100]="estado() === 'activo'"
        [class.text-green-800]="estado() === 'activo'"
        [class.bg-orange-100]="estado() === 'proximo-terminar'"
        [class.text-orange-800]="estado() === 'proximo-terminar'"
        [class.bg-red-100]="estado() === 'terminado'"
        [class.text-red-800]="estado() === 'terminado'"
        [class.bg-gray-100]="estado() === 'sin-tiempo'"
        [class.text-gray-800]="estado() === 'sin-tiempo'"
      >
        {{ titulo_estado() }}
      </span>
      <button
        (click)="modal_confirmacion_eliminar.set(true)"
        class="h-6 w-6 flex items-center justify-center rounded-full bg-red-100 hover:bg-red-200 text-red-700 transition-colors"
        title="Finalizar sesión"
      >
        <i class="bi bi-x-lg text-xs"></i>
      </button>
    </div>
  </div>

  <div class="p-3">
    <div class="space-y-1.5 sm:space-y-2">
      <div class="flex justify-between text-xs sm:text-sm">
        <span class="text-slate-600">Tiempo:</span>
        <span
          class="font-semibold"
          [class.text-green-700]="estado() === 'activo'"
          [class.text-orange-700]="estado() === 'proximo-terminar'"
          [class.text-red-700]="estado() === 'terminado'"
          [class.text-gray-700]="estado() === 'sin-tiempo'"
        >
          {{ tiempo_formateado() }}
        </span>
      </div>
      <div class="flex justify-between text-xs sm:text-sm">
        <span class="text-slate-600">Inicio:</span>
        <span class="font-semibold text-slate-900">
          {{ gestion_tiempo().inicio | date: 'HH:mm' }}
        </span>
      </div>
      <div class="flex justify-between text-xs sm:text-sm">
        <span class="text-slate-600">Termino:</span>
        <span class="font-semibold text-slate-900">
          {{ calcular_hora_termino() | date: 'HH:mm' }}
        </span>
      </div>
      <div class="flex justify-between text-xs sm:text-sm">
        <span class="text-slate-600">Items:</span>
        <span class="font-semibold text-slate-900">{{ gestion_tiempo().items.length }}</span>
      </div>
      <div class="flex justify-between text-xs sm:text-sm">
        <span class="text-slate-600">Total:</span>
        <span class="font-semibold text-slate-900">
          {{ calcular_total() | currency: 'S/. ' }}
        </span>
      </div>
    </div>

    <div class="mt-auto pt-3 grid grid-cols-2 gap-1">
      <button
        (click)="modal_agregar_producto.set(true)"
        class="flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white px-2 py-1.5 rounded text-xs sm:text-sm font-semibold transition-colors"
        title="Agregar producto"
      >
        <i class="bi bi-basket"></i>
        <span class="ml-1">Productos</span>
      </button>
      <button
        (click)="finalizarSesion()"
        class="flex items-center justify-center bg-green-600 hover:bg-green-700 text-white px-2 py-1.5 rounded text-xs sm:text-sm font-semibold transition-colors"
        title="Finalizar sesión"
      >
        <i class="bi bi-stop-circle"></i>
        <span class="ml-1">Cobrar</span>
      </button>
    </div>
  </div>
</div>
<app-dialog
  header="Agregar Producto"
  [(visible)]="modal_agregar_producto"
  [modal]="true"
  [closable]="true"
  size="sm"
  styleClass="max-w-[600px] w-[90vw]"
>
  @if (modal_agregar_producto() === true) {
    <app-agregar-producto-2
      [productos_carrito]="productos_carrito()"
      [sync_manual]="true"
      (agregar_productos)="onAgregarProductos($event)"
      (eliminar_producto)="onEliminarProducto($event)"
    />
  }
</app-dialog>

<app-dialog header="Realizar venta" [modal]="true" [(visible)]="modal_procesar_venta" size="6xl">
  @if (modal_procesar_venta() == true) {
    <app-procesar-venta
      [gestionTiempoId]="gestion_tiempo().id"
      (closedModal)="modal_procesar_venta.set(false)"
      (emitirVenta)="onEmitirVenta()"
    />
  }
</app-dialog>

<app-dialog
  header="Confirmar eliminación"
  [(visible)]="modal_confirmacion_eliminar"
  [modal]="true"
  [closable]="false"
  size="xs"
>
  @if (modal_confirmacion_eliminar() === true) {
    <app-modal-confirmacion
      mensaje="¿Estás seguro que deseas eliminar esta gestión de tiempo?<br>Esta acción no se puede deshacer."
      textoCancel="Cancelar"
      textoConfirm="Si"
      (confirmar)="eliminarGestionTiempo()"
      (cancelar)="modal_confirmacion_eliminar.set(false)"
    />
  }
</app-dialog>
